const orange = {
  100: '#FFB94F',
  10: '#FAF3E8',
};
export default orange;
